import { Component, computed, inject, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeCodet } from '@app/models/entity.model';
import { MediaComponent } from '@app/components/media/media.component';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { RelatedContentComponent } from '@app/components/related-content/related-content.component';
import { ContentLinkService } from '@app/services/contentLinks.service';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

@Component({
  selector: 'mobi-node-codet',
  templateUrl: './node-codet.component.html',
  styleUrls: ['./node-codet.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    MediaComponent,
    HeroTextComponent,
    BreadcrumbComponent,
    RelatedContentComponent,
    ParagraphLoaderComponent,
  ],
})
export class NodeCodetComponent {
  readonly entity = input.required<NodeCodet>();

  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
